import CheckboxInput from './InputCheckbox';
import IconCheckboxInput from '../icon-checkbox';

export { IconCheckboxInput, CheckboxInput };
export default CheckboxInput;
